export default "__VITE_ASSET__D11y3H7D__";